module.exports = "<div *ngFor=\"let item of mensaje; let i = index\">\n    <div class=\"alert alert-danger\" role=\"alert\"><img src=\"assets/img/icon/ico-danger.png\" alt=\"Danger Icon\">{{item}}\n        <fa name=\"times\" class=\"label-accion-rigth\" (click)=\"close(i);\"></fa>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/mensaje-label-negocio/mensaje-label-negocio.component.html
// module id = ./src/app/components/shared/mensaje-label-negocio/mensaje-label-negocio.component.html
// module chunks = main